import {
    useContext,
    useEffect,
    useState
} from 'react';
import Head from 'next/head';

import { RequestNextApi } from '../../api/Request';
import { ProgressContext } from '../../components/Context/progressContext';
import MarketingNavigation from '../../navigation/marketing';
import { showArticleBlock } from '../../utils/static-pages/function';
import { PAGES_SLUG } from '../../utils/static-pages/model';
import { ShowNotification } from '../../utils/notification/snackbarUtils';

export default function IndustryLeader() {
    const [articleBlocks, setArticleBlocks] = useState();
    const { state: progressContext, update: updateProgress } = useContext(ProgressContext);
    useEffect(() => {
        const fetchPage = async () => {
            try {
                const res = await RequestNextApi.post('/pages',
                    {
                        slug: PAGES_SLUG.INDUSTRY_LEADER,
                    }
                );
                if (res.data.success) {
                    setArticleBlocks(res.data.page.articleBlocks);
                } else {
                    ShowNotification.error('Fetch page failed');
                }
            } catch (error) {
                ShowNotification.error('Fetch page failed');
            }
        };

        const initPage = async () => {
            updateProgress({ isLoading: true });
            await fetchPage();
            updateProgress({ isLoading: false });
        };

        initPage();
    }, []);

    return (
        <>
            <Head>
                <title>Financial Advisors | Leading the Industry | Kingdom Advisors</title>
                <meta name="description" content="Kingdom Advisors leads the way for Christian financial advisors to integrate faith and work. Join a network of service providers, advisors, & industry leaders." />
            </Head>
            <MarketingNavigation>
                <div className='industry-leader'>
                    {articleBlocks && articleBlocks.map((item, index) => (
                        showArticleBlock(item, index)
                    ))}
                </div>
            </MarketingNavigation>
        </>
    )
}

IndustryLeader.getLayout = page => <>{page}</>;
IndustryLeader.isPublic = true;
